var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SocialAuthBtn',{staticClass:"linkedin-btn",attrs:{"id":"linkedin-login-btn","img":_vm.LinkedInLogo,"label":_vm.$t('shared.loginModule.socialAuthBtns.continueWithLinkedIn'),"color":"#0077b5","tiny":_vm.tiny},on:{"click":_vm.lLogIn}})
}
var staticRenderFns = []

export { render, staticRenderFns }